import { handle420 } from 'apis/HandleError';
import { fetchdata } from './FetchData';
import { apiConfig } from 'config';

export function bulkSoftwareUpdate(deviceIDs, softwareID, transferTime, activationTime) {
  let scopeDevices = {
    device_list: [...deviceIDs]
  };

  let postBody = {
    scope: scopeDevices,
    sw_identifier: softwareID,
    schedule: transferTime,
    ...(activationTime && { activationDate: activationTime })
  };

  return fetchdata(apiConfig.cmServiceBulkSoftwareUpdate, { method: 'POST', body: JSON.stringify(postBody) }).catch(
    (e) => {
      console.log('fetch data error = ' + e.message);
      switch (e.message) {
        case '420':
          handle420();
          break;
        case '400':
          throw new Error(
            'Failed to initiate software download: bad request. Either device(s) are not supported by the version or scheduled time is expired'
          );
        case '500':
          throw new Error('Failed to initiate software download: server error');
        default:
          throw new Error('Failed to initiate software download: reason unknown');
      }
      return;
    }
  );
}
